import { useContextState } from "../../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        container: {
            p: 2,
            mb: 1,
            borderRadius: 2,
        },
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
        },
        title: {
            display: "flex",
            alignItems: "center",
        },
        footer: {
            mt: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            height: '46px'
        },
        containerbuton:{
            display: 'flex',
            justifyContent: 'end'
        },
        titleText: {
            color: colors.color13
        },
        switch: {
            '& .MuiTypography-root':{
                color: colors.color13
            }
        }
    }
}

export { useStyles }
